import { render, staticRenderFns } from "./ivrRecognition.vue?vue&type=template&id=46903647"
import script from "./ivrRecognition.vue?vue&type=script&lang=js"
export * from "./ivrRecognition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports